import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import './update.css';
import suggestion from './resource/suggestion.png';
import security from './resource/security.png';

let faqUpdates= [];


export class Update extends Component {

  render() {

    return (
      <div className="Landing">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="contentHeaderText">
              Hier finden Sie aktuelle Hinweise zu den
                  Produkten, zu Sicherheit und Datenschutz
                  sowie Empfehlungen der Redaktion
              </div>
            <div className="UpdateRowTiles">

              <div className="UpdateTileDownOneTile center pointer " onClick={(event) => this.props.history.push("/suggestion")}>
                <div className="landingOneTileContent" >
                  <img src={suggestion} alt="Dienstleistung" /><br />
                  <div className="landingHeaderText">Empfehlungen</div>
                  <div className="landingContentText landingNotClikableProducts">
                    Gesetze und Verordnungen Datenschutz <br />
                    Studien Abrechnung <br />
                    Formulare weitere Hinweise <br />
                    weitere Empfehlungen <br />
                  </div>
                </div>
              </div>

              <div className="UpdateTileDownOneTile center pointer " onClick={(event) => this.props.history.push("/requirements")}>
                <div className="landingOneTileContent" >
                  <img src={security} alt="Dienstleistung" /><br />
                  <div className="landingHeaderText">IT-Sicherheit</div>
                  <div className="landingContentText landingNotClikableProducts">
                    Organisatorische Unterstützung <br />
                    Datenschutz <br />
                    Abrechnung <br />
                    weitere Hinweise <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer faqs={faqUpdates}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/update.js